export default "__VITE_ASSET__D39vUG0j__"